import checkapplyx from '@/view/check-apply-examine';

const checkx = {
    install:function (Vue) {
        Vue.component('checkx',checkapplyx)
    }
}
export default checkx;